import _axios from "@/axios";
import { reactive, ref } from "@vue/composition-api";
import { showSnackBar } from "@/composables/snackbar";
import { handleFormErrors } from "@/composables/form-error";

const catalogs = ref([]);
export function useCatalogs() {
  const catalogData = reactive({
    catalogForm: { cardModel: -1 },
    catalogFormRef: null,
    rules: {
      reversionRules: [(v) => (v && v >= 0) || "La reversion est obligatoire"],
      catalog_typeRules: [(v) => !!v || "Le type de catalogue est obligatoire"],
      priceRules: [(v) => !!v || "Le prix est obligatoire"],
      card_modelRules: [
        (v) =>
          v !== "Aucun modèle sélectionné" ||
          "Le modèle de carte est obligatoire",
      ],
      modeRules: [(v) => v >= 0 || "Le mode est obligatoire"],
    },
    createCatalogDialog: false,
    editCatalogDialog: false,
    modesChoice: [
      { text: "BASIC Card", value: 0 },
      { text: "FULL Card", value: 1 },
    ],
    reversionTypesChoice: [
      { text: "Devise", value: "devise" },
      { text: "Pourcentage", value: "percentage" },
    ],
    catalogTypesChoice: [
      { text: "Achat en ligne", value: 1 },
      { text: "E-Ticketing", value: 2 },
      { text: "Employés", value: 3 },
      { text: "Prévente", value: 4 },
    ],
    currenciesChoice: [
      "EUR",
      "AUD",
      "AED",
      "BHD",
      "CHF",
      "CAD",
      "DKK",
      "EGP",
      "GBP",
      "JPY",
      "NOK",
      "NZD",
      "SEK",
      "USD",
    ],
    firstLoad: true,
    isLoading: false,
  });

  function listCatalogs(clientId = null, groupId = null) {
    catalogData.isLoading = true;
    let routePath = "";
    if (clientId != null) {
      routePath = "/list-catalog/portal/" + clientId;
    } else if (groupId != null) {
      routePath = "/list-catalog/group/" + groupId;
    }

    return _axios
      .get(routePath)
      .then((response) => {
        catalogs.value = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        catalogData.firstLoad = false;
        catalogData.isLoading = false;
      });
  }

  function createCatalog(clientId = null, groupId = null) {
    catalogData.isLoading = true;
    catalogData.createCatalogDialog = true;
    if (clientId != null) {
      catalogData.catalogForm.client = clientId;
    }
    if (groupId != null) {
      catalogData.catalogForm.group = groupId;
    }

    if (catalogData.catalogFormRef != null) {
      const isValid = catalogData.catalogFormRef.validate();
      if (!isValid) {
        catalogData.isLoading = false;
        return;
      }
    }

    return _axios
      .post("/create-catalog", catalogData.catalogForm)
      .then(() => {
        listCatalogs(clientId, groupId);
        showSnackBar();
        catalogData.createCatalogDialog = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          catalogData.rules,
          catalogData.catalogFormRef
        );
      })
      .finally(() => {
        catalogData.isLoading = false;
      });
  }

  function updateCatalog(catalog) {
    catalogData.isLoading = true;
    catalogData.editCatalogDialog = true;
    if (catalogData.catalogFormRef != null) {
      const isValid = catalogData.catalogFormRef.validate();
      if (!isValid) {
        catalogData.isLoading = false;
        return;
      }
    }

    return _axios
      .put("/catalog/" + catalog.id, catalogData.catalogForm)
      .then(() => {
        let clientId = null;
        let groupId = null;
        if (catalog.client != null) {
          clientId = catalog.client.id;
        }
        if (catalog.group != null) {
          groupId = catalog.group.id;
        }
        listCatalogs(clientId, groupId);
        catalogData.editCatalogDialog = false;
        showSnackBar();
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          catalogData.rules,
          catalogData.catalogFormRef
        );
      })
      .finally(() => {
        catalogData.isLoading = false;
      });
  }

  function deleteCatalog(catalog) {
    return _axios
      .delete("/catalog/" + catalog.id)
      .then(() => {
        let clientId = null;
        let groupId = null;
        if (catalog.client != null) {
          clientId = catalog.client.id;
        }
        if (catalog.group != null) {
          groupId = catalog.group.id;
        }
        listCatalogs(clientId, groupId);
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  return {
    catalogs,
    catalogData,
    listCatalogs,
    createCatalog,
    updateCatalog,
    deleteCatalog,
  };
}
